import $ from 'jquery';
import WindowPopup from './utils/window-popup';

class SocialSharing {
    constructor (socialLinksSelector, webshareButton) {
        this.socialLinksSelector = socialLinksSelector;
        this.$webshareButton     = $(webshareButton);

        if (navigator.share) {
            this.$webshareButton.on('click', $.proxy(this.webShare, this));
        }
        else if (this.socialLinksSelector.length > 0) {
            $('body').on('click', this.socialLinksSelector, function(e) {
                e.preventDefault();

                WindowPopup($(this).attr('href'), 500, 300);
            });
        }
    }

    // eslint-disable-next-line
    webShare (e) {
        const $elem = $(e.currentTarget);

        navigator.share({
            title: $elem.data('share-title'),
            url  : $elem.data('share-url'),
        }).catch(console.error);
    }
}

export default SocialSharing;
